import { FC, useEffect, useState } from "react";
import { usePlanLink, useSinglePlanLink } from "../hooks";

import { LinkPlanPatch } from "../types/link.types";

import { useMicroNavigator } from "../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import { NodePlanPatch } from "../types/node.types";

export interface CreateUpdateLinkFormProps {
  isUpdate?: boolean;
  handleSubmit?: () => void;
  lableSubmitButton?: string;
  formDataValue?: FormDataType | null;
  setFormDataValue: (value: FormDataType | null | undefined) => void;
  isErrorStatuts?: HaveErrorStatus | null;
  isLoading?: boolean;
  errorMessage?: string | null;
}

export interface FormDataType {
  node1?: NodePlanPatch;
  node2?: NodePlanPatch;
}

export interface HaveErrorStatus {
  isErrorNode1ID: boolean;
  isErrorNode2ID: boolean;
  messageError?: string | null;
}

export default function withCreateUpdateLinkForm(
  isUpdate: boolean,
  CreateUpdateLinkFormView: FC<CreateUpdateLinkFormProps>
) {
  return function () {
    const [formData, setFormData] = useState<FormDataType | null | undefined>(
      {}
    );
    const [errorStatus, setErrorStatus] = useState<HaveErrorStatus | null>(
      null
    );

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { createNewLink, allLinkQuery } = usePlanLink();

    const { navigate } = useMicroNavigator();

    const {singlePlanLinkQuery, updatePlanLink} = useSinglePlanLink();

    const labelBtn = isUpdate ? "Modifier" : "Créer";




    const handleSubmit = () => {
      const formatedForm = convertFormDataToLink(formData);
      const error = checkValidityLink(formatedForm);

      if (error) {
        setErrorStatus(error);
        setErrorMessage(error.messageError || null);
        return;
      }

      if (isUpdate) {

        if (formData) {
          updatePlanLink.mutate({
            newLink: formatedForm,
            callback: (response) => {
              if (response.result) {
                allLinkQuery.refetch();
               navigate("list");
              }
              if (response.error) {
                const message = response.error.response.data.message;
                setErrorMessage(response.error.response.data.message);

                if (message.includes("Link already exist")) {
                  setErrorMessage("Un lien entre ces deux noeuds existe déjà");
                }
              }
            },
          });
        }

      } else {
        //Create new Link
        if (formData) {
          createNewLink.mutate({
            newLink: formatedForm,
            callback: (response) => {
              if (response.result) {
                allLinkQuery.refetch();
                navigate("list");
              }
              if (response.error) {
                const message = response.error.response.data.message;
                setErrorMessage(response.error.response.data.message);

                if (message.includes("Link already exist")) {
                  setErrorMessage("Un lien entre ces deux noeuds existe déjà");
                }
              }
            },
          });
        }
      }
    };

    useEffect(() => {
      if (isUpdate && singlePlanLinkQuery.data ){ setFormData({
        node1: {
          ...singlePlanLinkQuery.data.pl_link_content_node_1
        },
        node2: {
          ...singlePlanLinkQuery.data.pl_link_content_node_2
        },
      })
    }

    }, [singlePlanLinkQuery.data]);

    if ( isUpdate && singlePlanLinkQuery.isLoading ) {
      return <div>Chargement...</div>;
    }
    if(isUpdate && singlePlanLinkQuery.error) {
      return <div>Erreur de Chargement</div>
    }

    return (
      <CreateUpdateLinkFormView
        isUpdate={isUpdate}
        formDataValue={formData}
        setFormDataValue={setFormData}
        isErrorStatuts={errorStatus}
        lableSubmitButton={labelBtn}
        handleSubmit={handleSubmit}
        errorMessage={errorMessage || errorStatus?.messageError || null}
      />
    );
  };
}

export const convertFormDataToLink = (
  formData: FormDataType | undefined | null
): LinkPlanPatch => {
  return {
    pl_link_node_1: formData?.node1?.node_id,
    pl_link_node_2: formData?.node2?.node_id,
  };
};

export const checkValidityLink = (
  formData?: LinkPlanPatch | null
): HaveErrorStatus | null => {
  let formDataInit: HaveErrorStatus = {
    isErrorNode1ID: false,
    isErrorNode2ID: false,
    messageError: null,
  };

  if (!formData) {
    return {
      isErrorNode1ID: true,
      isErrorNode2ID: true,
      messageError: "Veuillez remplir les champs",
    };
  }

  let isAllValid = true;
  if (!formData.pl_link_node_1) {
    isAllValid = false;
    formDataInit.isErrorNode1ID = true;
  }

  if (!formData.pl_link_node_2) {
    isAllValid = false;
    formDataInit.isErrorNode2ID = true;
  }

  if (formData.pl_link_node_1 === formData.pl_link_node_2) {
    isAllValid = false;
    formDataInit.isErrorNode1ID = true;
    formDataInit.isErrorNode2ID = true;
    formDataInit.messageError = "Les deux noeuds doivent être différents";
  }

  if (isAllValid) {
    return null;
  }

  return formDataInit;
};
